import { unitUtils } from '@bootstrap-styled/utils'
import makeAppTheme from './app.theme'
const appTheme = makeAppTheme({})

const { /* detectUnit, rmUnit, */ math } = unitUtils

/**
 * Makes a chevron caret for dropdowns
 *
 * @param {String} dir Opts: down (Default), up, right, left
 * @param {Boolean} hasBase
 * @param {Number} offset
 * @param {Object} theme
 * @return {String} styles
 */
export const drawCaret = (dir = 'down', hasBase = true, offset = 0, theme = appTheme): string => {
    const styles: string[] = []
    if (hasBase) {
        styles.push(`
            display: inline-block;
            position: relative;
            width: 9px;
            height: 9px;
            color: ${theme['$caret-color'] || 'inherit'};
            border-top: ${theme['$caret-width']} solid transparent;
            border-right: ${theme['$caret-width']} solid;
            border-bottom: ${theme['$caret-width']} solid;
            border-left: ${theme['$caret-width']} solid transparent;
            border-radius: 0px 3px 0px 3px;
            margin-top: ${math.multiply(theme['$caret-width'], offset)};
            margin-left: ${theme['$caret-spacing']};
        `)
    }
    const toDirection = {
        up: () =>
            styles.push(`
            transform: rotate(-135deg);
            top: ${theme['$caret-width']};
            left: auto;
        `),
        right: () =>
            styles.push(`
            transform: rotate(-45deg);
            left: -${theme['$caret-width']};
            top: auto;
        `),
        left: () =>
            styles.push(`
            transform: rotate(135deg);
            left: ${theme['$caret-width']};
            top: auto;
            margin-left: 0;
            margin-right: ${theme['$caret-spacing']};
        `),
        down: () =>
            styles.push(`
            transform: rotate(45deg);
            top: -${theme['$caret-width']};
            left: auto;
        `)
    }

    if (!!{}.hasOwnProperty.call(toDirection, dir)) {
        toDirection[dir]()
    } else {
        toDirection['down']()
    }

    return styles.join('\n')
}

/**
 * Hides an element visually while still allowing the content to be
 * accessible to assistive technology, e.g. screen readers.
 *
 * @param {String} state Opts: unhide
 * @return {String} styles
 */
export const hideVisually = (state = ''): string => {
    if (state.toLowerCase() === 'unhide') {
        return `
            clip: auto;
            clip-path: none;
            height: auto;
            overflow: visible;
            position: static;
            width: auto;
        `
    }

    return `
        border: 0;
        clip: rect(1px, 1px, 1px, 1px);
        clip-path: inset(100%);
        height: 1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
    `
}
